import { isPlatformBrowser, NgForOf, NgIf } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { PAGES_AND_PATHS } from 'src/app/constants/pages-and-paths';
import { AuthenticationHelperService } from 'src/app/services/helpers/authentication-helper.service';
import { ChatHelperService } from 'src/app/services/helpers/chat-helper.service';
import { WebsocketsHelperService } from 'src/app/services/helpers/websockets-helper.service';
import { Conversation } from 'src/app/services/http-services/chat/chat-http-interfaces';
import { ChatHttpService } from 'src/app/services/http-services/chat/chat-http.service';
import { FollowersHttpService } from 'src/app/services/http-services/followers/followers-http.service';
import {UserRoles} from '../../../../enums/general-enums';
import {CheckActiveRoleModule} from '../../../../pipes/check-active-role/check-active-role.module';

@Component({
  selector: 'app-group-accounts',
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
    RouterModule,
    TranslateModule,
    CheckActiveRoleModule
  ],
  templateUrl: './group-accounts.component.html',
})
export class GroupAccountsComponent implements OnInit, OnDestroy {
  @Input() conversation!: Conversation;
  @Output() userRemoved = new EventEmitter<boolean>();
  loggedUser: any;
  participantsLeftChatSubscription: Subscription | undefined;
  PAGES_AND_PATHS = PAGES_AND_PATHS;

  constructor(
    private authenticationHelperService: AuthenticationHelperService,
    private chatHelperService: ChatHelperService,
    private websocketsHelperService: WebsocketsHelperService,
    private chatHttpService: ChatHttpService,
    private toastService: ToastrService,
    private followersHttpService: FollowersHttpService,
    @Inject(PLATFORM_ID) private platformId: string,
  ) { }

  ngOnInit(): void {
    this.clearSubscription();
    if (isPlatformBrowser(this.platformId)) {
      this.loggedUser = this.authenticationHelperService.getUserData;
    }
    this.listenIfParticipantLeftChat();
  }

  listenIfParticipantLeftChat() {
    this.websocketsHelperService.listenIfSomeoneLeftConversation(this.conversation.id);
    this.participantsLeftChatSubscription = this.websocketsHelperService.userLeft.subscribe((res: any) => {
      const userId = res.user.id;
      if (this.conversation.other_participants) {
        this.chatHelperService.removeParticipant(this.conversation.other_participants, userId);
      }
      if (this.conversation.non_admin_participants) {
        this.chatHelperService.removeParticipant(this.conversation.non_admin_participants, userId);
      }
    });
  }

  clearSubscription() {
    this.participantsLeftChatSubscription?.unsubscribe();
  }

  removeUserFromGroup(user: any) {
    let socketId;
    if (isPlatformBrowser(this.platformId)) {
      socketId = localStorage.getItem('socketId');
    }
    this.chatHttpService.removeParticipantFromGroupV2(this.conversation.id, user.id, socketId).subscribe((response: any) => {
      this.toastService.success('User successfully removed!');
      this.userRemoved.emit(true);
      // this.chatHelperService.refreshUsersGroupAccounts(true);
      this.chatHelperService.removeParticipant(this.conversation.other_participants, user.id);
      this.chatHelperService.removeParticipant(this.conversation.non_admin_participants, user.id);
    })
  }

  ngOnDestroy(): void {
    this.clearSubscription();
  }

  followUnfollowUser(id: number) {
    this.followersHttpService.followUnfollowUser(id).subscribe((response: any) => {
      let userIndex = this.conversation.non_admin_participants?.findIndex((user: any) => user.id === id);
      if (this.conversation.non_admin_participants && userIndex) {
        this.conversation.non_admin_participants[userIndex].am_i_following_this_user = response.data.am_i_following_this_user;
        this.toastService.success(this.conversation.non_admin_participants[userIndex].am_i_following_this_user ? 'User has been followed' : 'User has been unfollowed!');
      }
    })
  }

  followUnfollowAdmin(id: number) {
    this.followersHttpService.followUnfollowUser(id).subscribe((response: any) => {

      if (this.conversation.admin_participants) {
        let userIndexAdmin = this.conversation.admin_participants?.findIndex((user: any) => user.id === response.data.id);
        this.conversation.admin_participants[userIndexAdmin].am_i_following_this_user = response.data.am_i_following_this_user;
        this.toastService.success(this.conversation.admin_participants[userIndexAdmin].am_i_following_this_user ? 'User has been followed' : 'User has been unfollowed!');
      }
    })
  }

  protected readonly UserRoles = UserRoles;
}
